import { api } from "../api/client";

/**
 * The Klaviyo key, as the panel sees it (`R-ANL-10`). Hand-written against
 * `packages/functions/src/settings-klaviyo.ts`.
 *
 * Write-only: the key is sent and never comes back. What the panel is told is whether one is set,
 * its last four characters, and the account Klaviyo said it opens.
 */
export interface KlaviyoStatus {
  configured: boolean;
  hint: string | null;
  account: string | null;
  updatedAt: string | null;
}

export const klaviyo = {
  read: () => api.get<{ klaviyo: KlaviyoStatus }>("/api/settings/klaviyo"),
  save: (apiKey: string) =>
    api.put<{ klaviyo: KlaviyoStatus }>("/api/settings/klaviyo", { apiKey }),
  remove: () => api.del<{ klaviyo: KlaviyoStatus }>("/api/settings/klaviyo"),
};
